const CompanyBillDetails = () => {
  return <p>Tarifa de Fatura</p>
}

export default CompanyBillDetails
